export const TYPE_CALL = 'call';
export const TYPE_SALESMAN_VISIT = 'salesmanVisit';
export const TYPE_VISIT = 'visit';
